import React, { forwardRef } from 'react';

function IconCheckBox({ canChange = true, ...props }, ref)  {
    const handleClick = e => {
        props.onChange && canChange && props.onChange(!props.value);
    }
    
    const d = props.value ? '' : 'disabled';
    const className = props.className ? ` ${props.className}` : '';
    return <div ref={ref} className={`dspx-icon-checkbox ${d}${className}`} onClick={handleClick} style={props.style} >
        {props.icon} {props.children}
    </div>        
}
export default forwardRef(IconCheckBox)